module.exports = __webpack_public_path__ + "static/w-hasna-315cbdeb768bb43a92290ce0ac2ee316.jpeg";